class LocationHandler {
  constructor() {
    this.PDPCartBtnElements = document.querySelectorAll(".data-submit-btn");
    this.POPagePreorderMsgElements =
      document.querySelectorAll(".backorder-message");
    this.POPageProductTables = document.querySelectorAll(
      ".purchase-order .p-order-table"
    );
  }

  onPageLoad() {
    this.locationHandler();
  }

  locationHandler() {
    if ( localizationCountryCode != '' ) {
      let countrycode = localizationCountryCode,
        euCountryCodes = ["AT", "BE", "BG", "HR", "CY",
                          "CZ", "DK", "EE", "FI", "FR",
                          "DE", "GR", "HU", "IE", "IT",
                          "LV", "LT", "LU", "MT", "NL",
                          "PL", "PT", "RO", "SK", "SI",
                          "ES", "SE", "NO"];
      if ( countrycode == 'GB' ) countrycode = 'UK';
      const country = countrycode.toLowerCase();
      let prefix = "";
      if (["us", "uk", "ca", "au", "nz"].includes(country)) {
        prefix = country;
      } else if (euCountryCodes.includes(countrycode)) {
        prefix = 'eu';
      }

      console.log('localizationCountryCode');
      console.log(localizationCountryCode, prefix);
      if (prefix) {
        this.pdp(prefix);
        this.po(prefix);
      } else {
        console.log("We are not shipping to your location.");
      }
    } else {
      fetch(`/browsing_context_suggestions.json`)
        .then((response) => response.json())
        .then((data) => {
          let countrycode = data.detected_values.country.handle,
          euCountryCodes = ["AT", "BE", "BG", "HR", "CY",
                            "CZ", "DK", "EE", "FI", "FR",
                            "DE", "GR", "HU", "IE", "IT",
                            "LV", "LT", "LU", "MT", "NL",
                            "PL", "PT", "RO", "SK", "SI",
                            "ES", "SE", "NO"];
          if ( countrycode == 'GB' ) countrycode = 'UK';
          const country = data?.detected_values.country.handle.toLowerCase();
          let prefix = "";
          if (["us", "uk", "ca", "au", "nz"].includes(country)) {
            prefix = country;
          } else if (euCountryCodes.includes(countrycode)) {
            prefix = 'eu';
          }

          console.log(data, prefix);
          if (prefix) {
            this.pdp(prefix);
            this.po(prefix);
          } else {
            console.log("We are not shipping to your location.");
          }
        })
        .catch((error) => {
          console.error(error);
        });

    }
  }

  pdp(prefix) {
    const comingsoonStatusKey = `${prefix}_add_coming_soon_tag`;

    const preorderStatusKey = `${prefix}_preorder`;
    const preorderMessageKey = `${prefix}_product_page_messaging`;

    console.log(preorderStatusKey);

    if (comingsoonStatusKey) {
      this.PDPCartBtnElements.forEach((btn) => {
        const comingsoonStatus = btn.dataset?.[comingsoonStatusKey];

        if (comingsoonStatus === "true") {
          btn.innerHTML = '<span class="add-text">Coming Soon</span>';
          btn.classList.add("disabled");
        } else {
          const preorderStatus = btn.dataset?.[preorderStatusKey];
          const preorderMessage = btn.dataset?.[preorderMessageKey];

          if (preorderStatus === "true") {
            btn.innerHTML = '<span class="add-text">Pre-order</span>';
          }

          const msgEle = btn
            .closest("[data-product-form]")
            .querySelector("[data-product-preorder-message]");

          if (preorderStatus === "true" && preorderMessage !== "" && msgEle) {
            msgEle.innerHTML = `
                      <div class="align-items-center mt-2 mb-lg-3 mb-2 py-1 formatted-list fw-normal">
                         <ul>${preorderMessage}</ul>
                      </div>
                          `;
          }
        }
      });
    }
  }

  po(prefix) {
    // Show preorder message
    const preorderStatusKey = `${prefix}_preorder`;
    const preorderMessageKey = `${prefix}_product_page_messaging`;

    this.POPagePreorderMsgElements.forEach((msg) => {
      const preorderStatus = msg.dataset?.[preorderStatusKey];
      const preorderMessage = msg.dataset?.[preorderMessageKey];

      if (preorderStatus === "true") {
        msg.innerText = `Pre-Order. ${preorderMessage}`;
        // msg.parentElement.querySelector(".preorder-label").innerHTML =
        //   "Pre-Order";
      }
    });

    // Hide coming-soon products
    const comingsoonStatusKey = `${prefix}_add_coming_soon_tag`;

    this.POPageProductTables.forEach((table) => {
      const productRows = table.querySelectorAll("[data-product-row]");

      let hidAll = true;
      productRows.forEach((row) => {
        const comingsoonStatus = row.dataset?.[comingsoonStatusKey];
        if (comingsoonStatus === "true") {
          row.remove();
        } else {
          hidAll = false;
        }
      });

      if (hidAll) {
        table.remove();
      }
    });
  }
}

const locationHandler = new LocationHandler();
window.addEventListener("DOMContentLoaded", () => locationHandler.onPageLoad());
